<template>
  <div v-if="!loading" class="sp-mode">
    <sp-site-header/>
    <article>
      <div id="top_label">
        <div class="container">
          <h1>履歴一覧</h1>
          <span class="now-time">{{ today | jpYYYYMMDDdd }}現在</span>
          <br>
          <span>過去45日間の履歴が表示されます。</span>
          <br>
          <span>本日分は一つ前のページ（路線選択画面）から、路線名をタップしてください。</span>
        </div>
      </div>
      <div class="line-label container">
        <h4 v-if="line">
          <span class="line-mark">
            <i :style="{ background: line.line_color_1, color: lineSignColor(line.line_sign_color_1) }">{{ line.line_sign_1 }}</i><i v-if="line.line_sign_2" :style="{ background: line.line_color_2, color: lineSignColor(line.line_sign_color_2) }">{{ line.line_sign_2 }}</i><i v-if="line.line_sign_3" :style="{ background: line.line_color_3, color: lineSignColor(line.line_sign_color_3) }">{{ line.line_sign_3 }}</i>
          </span>
          <div class="line-info">
            <span class="line-name">{{ line.line_name }}</span>
            <span class="section-name">{{ line.section_name }}</span>
          </div>
        </h4>
      </div>
      <div class="container line-accordion" role="tablist">
        <div no-body v-bind:key="history.date" v-for="history in getHistorys()" class="line-item">
          <b-card-header header-tag="header" role="tab">
            <a v-b-toggle="'accordion-' + `${history.date}`">
              <font-awesome-icon :icon="['fas', 'chevron-down']" v-bind:class="{ delayexist : history.have_delay_certificate === true }"></font-awesome-icon>
              <font-awesome-icon :icon="['fas', 'chevron-up']" v-bind:class="{ delayexist : history.have_delay_certificate === true }"></font-awesome-icon>
              {{ history.date | jpmonthday }}
            </a>
          </b-card-header>
          <b-collapse :id="'accordion-' + `${history.date}`" accordion="my-accordion" role="tabpanel">
            <table>
              <tbody>
                <tr class="text-center" v-bind:key="zoneData.time_zone_id" v-for="zoneData in history.data">
                  <td class="timeZone-label">{{ zoneData.time_zone_display_name }}</td>
                  <td class="delay-info" v-if="zoneData.delay_certificate">
                    <router-link :to="{ name: 'SpHistoryDelayCertificate', params: { today: 'history', areaId: areaId, lineId: lineId, targetDate: history.date, timeZoneId: zoneData.time_zone_id }}" v-bind:class="{ is_modified: zoneData.is_modified === true }" v-if=" zoneData.delay_certificate_item_type === 'DELAY_CERTIFICATE'" target="_blank">
                      <div class="str-modified" v-html="getModifiedString(zoneData.is_modified)"></div>
                      <div class="arrow-right"><font-awesome-icon :icon="['fas', 'caret-right']"></font-awesome-icon></div>
                      <div class="delay-time">{{ zoneData.delay_certificate }}</div>
                    </router-link>
                    <div class="string-delay" v-bind:class="{ maintenance:  zoneData.delay_certificate === '調整中' }" v-else-if="zoneData.delay_certificate_item_type === 'OTHERS'">
                      <div class="str-modified" v-html="getModifiedString(zoneData.is_modified)"></div>
                      <div class="str-delay-info">{{ zoneData.delay_certificate }}</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-collapse>
        </div>
      </div>
      <div class="container">
        <div v-if="historyMaintenanceCSV" id="maintenance_csv" v-html="historyMaintenanceCSV"></div>
      </div>
      <div class="container more-btn" v-if="historys.length > 0">
        <b-button v-if="displayAll === false" variant="btn-block" v-on:click="ondisplayAll">
          もっと見る
          <span v-if="displayAll === false"><font-awesome-icon :icon="['fas', 'caret-down']"></font-awesome-icon></span>
        </b-button>
        <b-button v-if="displayAll === true" variant="btn-block" v-on:click="ondisplayAll">
          閉じる
          <span v-if="displayAll === true"><font-awesome-icon :icon="['fas', 'caret-up']"></font-awesome-icon></span>
        </b-button>
      </div>
    </article>
    <sp-site-footer/>
  </div>
</template>

<script>
import SpSiteHeader from '@/components/sp/SpSiteHeader'
import SpSiteFooter from '@/components/sp/SpSiteFooter'
import { mapState } from 'vuex'
var moment = require('moment')
export default {
  name: 'SpHistory',
  components: {
    SpSiteHeader,
    SpSiteFooter
  },
  data () {
    const today = moment()
    const areaId = parseInt(this.$route.params.areaId, 10)
    const lineId = parseInt(this.$route.params.lineId, 10)
    return {
      today,
      areaId,
      lineId,
      area: undefined,
      line: undefined,
      displayAll: false
    }
  },
  methods: {
    getModifiedString (isModified) {
      if (isModified) {
        return '変更'
      } else {
        return '&nbsp;'
      }
    },
    isNum (num) {
      return num !== undefined && /^\d+$/.test(num) === true
    },
    ondisplayAll () {
      this.displayAll = !this.displayAll
    },
    getHistorys () {
      if (this.displayAll) {
        return this.historys
      } else {
        return this.historys.slice(0, 7)
      }
    },
    lineSignColor (data) {
      return data === '' ? '#000' : data
    },
    init () {
      if (this.areaStatus !== 'init' || this.timeZoneStatus !== 'init') {
        return
      }
      this.area = this.areas.find(area => area.area_id === this.areaId)
      if (this.area === undefined) {
        this.$router.push({name: 'SpPageNotFound'})
        return
      }
      this.line = this.area.lines.find(line => line.line_id === this.lineId)
      if (this.line === undefined) {
        this.$router.push({name: 'SpPageNotFound'})
        return
      }
      this.$store.dispatch('history/all', [this.lineId, this.timeZones])
      this.$store.dispatch('externalData/historyMaintenanceCSV', this.areaId)
      this.checkLoaded()
    },
    checkLoaded () {
      const timer = setInterval(() => {
        if (this.historyStatus === 'init') {
          clearInterval(timer)
          this.$store.commit('loading/setStatus', false)
        }
      }, 100)
    }
  },
  created () {
    if (!this.isNum(this.$route.params.areaId) ||
      !this.isNum(this.$route.params.lineId)) {
      this.$router.push({name: 'SpPageNotFound'})
      return
    }
    this.$store.dispatch('areaLine/all')
    this.$store.dispatch('timeZone/all')
    const unwatchAreaLine = this.$store.watch(
      (state) => state.areaLine.status,
      (value) => {
        if (value === 'init') {
          unwatchAreaLine()
          this.init()
        }
      }
    )
    const unwatchTimezone = this.$store.watch(
      (state) => state.timeZone.status,
      (value) => {
        if (value === 'init') {
          unwatchTimezone()
          this.init()
        }
      }
    )
  },
  computed: {
    ...mapState('timeZone', {
      timeZones: state => state.timeZones,
      timeZoneStatus: state => state.status
    }),
    ...mapState('history', {
      historys: state => state.historys,
      historyStatus: state => state.status
    }),
    ...mapState('externalData', {
      historyMaintenanceCSV: state => state.historyMaintenanceCSV
    }),
    ...mapState('areaLine', {
      areas: state => state.areas,
      areaStatus: state => state.status
    }),
    ...mapState('loading', {
      loading: state => state.status
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/variables';
.line-item {
    border-bottom: solid 1px #ccc;
}
.card-header {
  border-radius: 0 !important;
  border-top: none !important;
  padding-bottom: 0.46rem !important;
}
#top_label {
  border-bottom: solid 2px #0072b9;
  padding-bottom: 1.25rem;
  h1 {
    font-size: 1.3rem;
    font-weight: 600;
    line-height: 2.5rem;
    padding: 0;
    margin-top: 16px;
  }
  span {
    margin-bottom: 0;
    &.now-time {
      line-height: 1.1rem;
      font-size: 1rem;
      font-weight: 600;
      line-height: 1.1rem;
      color: $primary;
    }
  }
}
.line-label {
  margin-top: 1.25rem;
  margin-bottom: 0.625rem;
  h4 {
    border: solid 2px #f5f5f5;
    padding-bottom: 1.0rem;
    padding-top: 1.0rem;
    font-size: 1.06rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 1.875rem;
    padding-right: 1.875rem;
    .line-mark {
      display: inline-block;
      i {
        margin-bottom: 1px;
        display: block;
        text-align: center;
        color: #fff;
        font-style: normal;
        line-height: 2.25rem;
        font-size: 1.75rem;
        width: 2.25rem;
        height: 2.25rem;
        border-radius: 0.25rem;
        font-weight: 600;
        padding: 0.05rem;
      }
    }
    .line-info {
      text-align: left;
      display: inline-block;
      margin-left: 0.75rem;
      span {
        display: block;
        &.line-name {
          font-weight: 600;
          font-size: 1.25rem;
          line-height: 1.25rem;
          margin-bottom: 0.44rem;
          color: #1a1a1a;
        }
        &.section-name {
          font-weight: 600;
          font-size: 0.85rem;
          line-height: 0.85rem;
          color: #a7a7a7;
        }
      }
    }
  }
 }
#maintenance_csv {
  margin-top: 1.25rem;
}
.line-accordion {
  header {
    background-color: #fff;
    border-top: solid 1px #ccc;
    border-bottom: none;
    padding-top: 1.0rem;
    padding-bottom: 1.0rem !important;
    padding-left: 0;
    a {
      font-size: 1.125rem;
      line-height: 1.625rem;
      display: block;
      font-weight: 600;
      &.collapsed {
        .fa-chevron-down {
          display: inline-block;
        }
        .fa-chevron-up {
          display: none;
        }
      }
      &.not-collapsed {
        .fa-chevron-down {
          display: none;
        }
        .fa-chevron-up {
          display: inline-block;
        }
      }
      .fa-chevron-down {
        display: none;
        color: #bbb;
        &.delayexist {
          color: $primary;
        }
        width: 1.5rem;
        line-height: 1.5rem;
        font-size: 1.125rem;
      }
      .fa-chevron-up {
        display: none;
        color: #bbb;
        &.delayexist {
          color: $primary;
        }
        color: #bbb;
        width: 1.5rem;
        line-height: 1.5rem;
      font-size: 1.125rem;
      }
    }
  }
  table {
    width: 100%;
    border-collapse: separate;
    tr {
      line-height: 2.5rem;
      td {
        &.timeZone-label{
          width: 6.5rem;
          font-size: 0.8rem;
          background-color: #f5f5f5;
          font-weight: 600;
        }
        &.delay-info {
          a {
            border: solid 2px #abcbe8;
            width: 100%;
            display: block;
            position: relative;
            font-size: 0.8rem;
            font-weight: 600;
            background-color: #e0f2ff;
            div {
              display: block;
              &.str-modified {
                padding-left: 0.3rem;
                font-size: 0.6rem;
                position: absolute;
                color: #fa7d00;
              }
              &.delay-time {
                font-size: 0.9rem !important;
              }
              &.arrow-right {
                width: 1rem;
                font-size: 1.0rem !important;
                position: absolute;
                right: 0;
              }
            }
          }
          .string-delay {
            color: #a7a7a7;
            padding: 2px;
            &.maintenance{
              color: #fa7d00;
            }
            div {
              &.str-modified {
                float: left;
                padding-left: 0.3rem;
                font-size: 0.6rem;
                position: absolute;
                color: #fa7d00;
              }
              &.str-delay-info {
                font-size: 0.75rem !important;
              }
            }
          }
        }
        &.no-info {
          width: 63.5%;
          color: #a7a7a7;
        }
        &.active {
          background-color: #e0f2ff;
        }
      }
    }
  }
}
.more-btn {
  padding-top: 2.5rem;
  &.container {
    text-align: center;
  }
  button {
    background-color: white;
    color: black;
    border-radius: 1;
    width: 8.125rem;
    margin: auto;
    border-color: #ccc;
    &:active {
      color: black !important;
      background-color: white !important;
      border-color: #ccc !important;
    }
    &:focus {
      box-shadow: none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/SpHistory.vue